import { Widget } from '..'
import { ResizeAction } from './ResizeAction'

enum ResizeDirection {
  horizontal = 'horizontal',
  vertical = 'vertical',
  any = 'any'
}

enum ResizeUnit {
  grid = 'grid',
  pixel = 'pixel'
}

type RowHeightSet = { [rowUUID: string]: number }

type ResizeCoords = { x: number, y: number }

type ResizeWidgetGetterFunction = () => Widget

type ResizeStartEventCallbackFunction = (action: ResizeAction, direction: ResizeDirection) => void
type ResizeEventCallbackFunction = (action: ResizeAction, size: number, direction: ResizeDirection) => void
type ResizeEndEventCallbackFunction = (action: ResizeAction) => void

export { ResizeCoords, ResizeDirection, ResizeEndEventCallbackFunction, ResizeEventCallbackFunction, ResizeStartEventCallbackFunction, ResizeUnit, ResizeWidgetGetterFunction, RowHeightSet }
